import { client } from '@/common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';

const mutationCreateMerchantAccount = (onSuccess, onError) => {
    return {
        mutationFn: ({ provider, label, email, contractProfiles }) => {
            return client.post(
                CONTRACT_ACCESS.CREATE.url,
                { provider: provider, label: label, email: email, contractProfiles: contractProfiles }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateMerchantAccount;